/* ==== Modal pop up script ==== */

let modalDelay = 10; // Number of seconds after load event fires to delay opening the pop up

let reshowModal = false; // Manages whether to show the modal in the event of submission success or error

const signedUpInStorage = localStorage.getItem('signedUp') === 'true' ? true : false; // Seeks the signedUp value from local storage

// Store current timestamp
function storeModalTimestamp() {
    const now = Date.now();
    localStorage.setItem('modalLastShown', now.toString());
}

// Check whether the modal can be shown
function canShowModal() {
    if (reshowModal) { // Manages whether the modal should be shown again after submission or error
        return true;
    }
    if (window.innerHeight > 400) { // check that viewport is tall enough

        const modalLastShown = localStorage.getItem('modalLastShown');
        const now = Date.now();

        if (modalLastShown && !signedUpInStorage) {
            const daysSinceShown = (now - parseInt(modalLastShown, 10)) / (1000 * 86400); // Calculate the days since last shown
            return daysSinceShown >= 5; // Returns true if 5 or more days have passed
        }

        return true; // If the modal has never been shown, we can show it
    }
    return false;
}

function showModalConditionally() {

    if (document.querySelector('#modal-refer') !== null && typeof(document.querySelector('#modal-refer')) !== "undefined") {
        document.getElementById('modal-refer').value += window.location.href; // Append location info to the hidden input
    }
  
    if (canShowModal()) {
        const subscribeModal = document.getElementById('subscribe-modal');
        setTimeout(() => {
            document.body.style.opacity = 0.8;
            subscribeModal.style.display = "flex";
            subscribeModal.showModal();
            subscribeModal.style.opacity = 1;
            storeModalTimestamp(); // Store timestamp on first open
            const closeButton = document.getElementById('modal-close-icon');
            closeButton.addEventListener('click', closeModal); // set close button behaviour

            // Manually implement a workaround for the cancel event
            document.addEventListener('click', function (event) {
                const withinBoundaries = event.composedPath().includes(subscribeModal);
                if (!withinBoundaries) {
                    closeModal();
                }
            });

            // Close the modal if the backdrop (margin area) is clicked
            subscribeModal.addEventListener('click', function (e) {
                // Check if the clicked element is the dialog itself and not its children
                if (e.target === subscribeModal) {
                    closeModal();
                }
            });

        }, modalDelay * 1000);
    }
}

function closeModal() {
    const subscribeModal = document.getElementById('subscribe-modal');
    subscribeModal.style.opacity = 0;
    document.body.style.opacity = 1;
    setTimeout(() => {
        subscribeModal.close();
    }, 500);
}

window.addEventListener('load', showModalConditionally);